export default "__VITE_ASSET__Bp2G8jod__"